// MIT License - Copyright (c) 2026 Doug McNall

import { starSystems, starPositions } from './StarSystemsConfig';
import { warpGates, warpGatePositions } from './WarpGatesConfig';
import { MassEffectAliensPlanets } from './AliensConfig';

export const universeMassEffect = {
  id: 'masseffect',
  starSystems,
  starPositions,
  warpGates,
  warpGatePositions,
  aliens: MassEffectAliensPlanets
};

export default universeMassEffect;
